import { useState } from "react";
import API from "../lib/api";
import Reveal from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function Signup() {
  const { lang, t } = useLang();
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (state === "sending") return;
    setState("sending");
    try {
      await API.post("/signups", { email, language: lang, website: hp });
      setState("success");
    } catch (err) {
      setState("error");
    }
  };

  return (
    <section id="signup" className="bg-espresso py-24 text-cream sm:py-28" data-testid="signup-section">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="font-serif text-3xl font-light italic sm:text-4xl" data-testid="signup-heading">
            {t.signup.heading}
          </h2>
          <p className="mt-4 text-base text-cream/65">{t.signup.sub}</p>

          {state === "success" ? (
            <p className="mt-10 font-serif text-2xl italic text-ochre" data-testid="signup-success">
              {t.signup.success}
            </p>
          ) : (
            <form onSubmit={submit} className="mx-auto mt-10 flex flex-col gap-5 sm:flex-row" data-testid="signup-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.signup.placeholder}
                data-testid="signup-input"
                className="ttwk-input ttwk-input-dark flex-1 text-center sm:text-left"
                aria-label={t.signup.placeholder}
              />
              <input
                className="honeypot"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                value={hp}
                onChange={(e) => setHp(e.target.value)}
                data-testid="signup-honeypot"
              />
              <button
                type="submit"
                disabled={state === "sending"}
                data-testid="signup-button"
                className="rounded-full bg-ochre px-8 py-4 text-[11px] uppercase tracking-[0.2em] text-espresso transition-colors duration-300 hover:bg-cream disabled:opacity-50"
              >
                {state === "sending" ? t.signup.sending : t.signup.button}
              </button>
            </form>
          )}

          {state === "error" && (
            <p className="mt-4 text-xs text-ochre" data-testid="signup-error">
              {t.signup.error}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
